<main class="container">

    <!-- ورود به حساب کاربری -->

    <div class="modal show bg-secondary" style="display: block;">

        <div class="modal-dialog modal-dialog-centered flex-column justify-content-center">

            <div class="modal-content">

                <div class="modal-header">

                    <h2 class="modal-title mb-0" id="exampleModalLabel">

                        {{ bLoginMode ? 'ورود به حساب کاربری' : 'ثبت نام' }}

                    </h2>

                    <button type="button" class="btn" (click)="dismissModal()">

                        <mat-icon class="mat-18">close</mat-icon>

                    </button>

                </div>

                <form [formGroup]="signUpModel" class="modal-body">

                    <div class="d-none alert alert-warning">

                        <p class="mb-0">این طرح صرفاً به‌منظور تخصیص سوخت به دارندگان مجوز صیادی معتبر صادره از سازمان
                            شاپد اجرا می‌گردد. بدیهی است ثبت‌نام افراد فاقد مجوز معتبر، هیچ‌گونه تعهدی برای سازمان
                            شاپد در خصوص تخصیص سوخت ایجاد نخواهد کرد.</p>

                    </div>

                    <h2 class=""> {{ !bSendOtp ? '' : 'کد تأیید را وارد کنید' }} </h2>

                    <!-- ثبت‌ نام یا OTP -->

                    <ng-container *ngIf="!bLoginMode">

                        <span class="">

                            {{ !bSendOtp ? '' : otpMessage | faNum}}

                            <span *ngIf="bSendOtp" id="changeNumber-btn" class="change-number" (click)="changeNumber()">

                                تغییر شماره

                            </span>

                        </span>

                    </ng-container>

                    <!-- پیام حالت لاگین -->

                    <span *ngIf="bLoginMode">

                        شماره موبایل متعلق به خودتان را وارد کنید.

                    </span>

                    <!-- فیلد موبایل -->

                    <ng-container *ngIf="isLoginMode">

                        <div class="form-group has-icon direction-ltr">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">phone_iphone</mat-icon>

                            </span>

                            <input class="mt-4 w-100 form-control" formControlName="strMobile"
                                [placeholder]="valid_PlaceHolder | faNum" inputmode="numeric"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')" [maxlength]="valid_MaxLength"
                                type="text" />

                        </div>

                    </ng-container>

                    <!-- قوانین در حالت لاگین -->

                    <div *ngIf="isLoginMode" class="d-flex mt-2 rules-wrapper">

                        <input type="checkbox" formControlName="rules" (change)="checkRules($event)" required>

                        <label class="px-1">

                            <a class="pointer" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کردم و موافقم

                        </label>

                    </div>

                    <!-- فرم ثبت‌ نام -->

                    <ng-container *ngIf="isSignUpMode">

                        <ng-container *ngIf="signUpModel.get('tiFloats')?.value > 0">

                            <div class="alert alert-info">
    
                                <p class="mb-0"> این مالک {{ signUpModel.get('tiFloats')?.value | faNum}} شناور به نام خود دارد. </p>
    
                            </div>

                        </ng-container>

                        <!-- نام -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">person</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strName" placeholder="* نام">

                        </div>

                        <!-- نام خانوادگی -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">person</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strFamily"
                                placeholder="* نام خانوادگی">

                        </div>

                        <!-- کدملی مالک شناور -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">badge</mat-icon>

                            </span>

                            <input class="my-3 w-100 form-control" formControlName="strID"
                                [ngClass]="signUpModel.get('strID').value ? 'direction-ltr' : ''"
                                placeholder="* کدملی مالک شناور" inputmode="numeric" maxlength="10"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')" />

                        </div>

                        <!-- استان -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">apartment</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="strStateCode"(change)="getCity($event.target.value)">

                                <option value=""> * استان</option>

                                <option *ngFor="let s of lst_States" [value]="s.strState">{{ s.strStateName }}</option>

                            </select>

                        </div>

                        <!-- شهر -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">apartment</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="strCity">

                                <option value="">* شهر</option>

                                <option *ngFor="let c of list_City" [value]="c.strCity.trim()">

                                    {{ c.strCityName }}

                                </option>

                            </select>

                        </div>

                        <!-- نام تعاونی  -->
                        <div class="form-group has-icon">
                            <span class="form-control-icon">
                                <mat-icon class="mat-18">houseboat</mat-icon>
                            </span>
                            <input class="w-100 mb-3 form-control" placeholder=" نام تعاونی" formControlName="strCooperativeName">
                        </div>

                        <!-- نوع شناور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">directions_boat</mat-icon>

                            </span>

                            <select class="w-100 mb-3" formControlName="tiFloatingType">

                                <option value=""> * نوع شناور </option>

                                <option *ngFor="let f of lst_FloatingType" [value]="f.tiFloatingType">

                                    {{ f.strFloatingType }}

                                </option>

                            </select>

                        </div>

                        <!-- برند موتور  -->
                        <div class="form-group has-icon">
                            <span class="form-control-icon">
                                <mat-icon class="mat-18">anchor</mat-icon>
                            </span>
                            <input class="w-100 mb-3 form-control" placeholder=" برند موتور" formControlName="strMotorBrand">
                        </div>
                        
                        <!-- نوع موتور  -->
                        <div class="form-group has-icon">
                            <span class="form-control-icon">
                                <mat-icon class="mat-18">anchor</mat-icon>
                            </span>
                            <input class="w-100 mb-3 form-control" placeholder=" نوع موتور" formControlName="strMotorType">
                        </div>

                        <!-- توان موتور شناور  -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">electric_bolt</mat-icon>

                            </span>

                            <input class="w-100 mb-3 form-control" placeholder="* توان موتور شناور"
                                [ngClass]="signUpModel.get('iPower').value ? 'direction-ltr' : ''"
                                formControlName="iPower" inputmode="numeric"
                                oninput="this.value=this.value.replace(/[^0-9]/g,'')">

                        </div>

                        <!-- شناسه شناور  -->

                        <div *ngIf="false" class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">card_membership</mat-icon>

                            </span>

                            <input class="w-100 mb-3 form-control " placeholder=" * شناسه شناور"
                                [ngClass]="signUpModel.get('strLicenseNo').value ? 'direction-ltr' : ''"
                                formControlName="strLicenseNo">

                        </div>

                        <!-- آدرس محل نصب -->

                        <div class="form-group position-relative has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">add_location_alt</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strAddress"
                                [placeholder]='addressPlaceHolder'>

                            <button class="btn btn-warning rounded" (click)="show_Map()">

                                <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>

                            </button>

                            <custom-map *ngIf="openMap" [strValue]="mdl_Map.get('strAddress')?.value"
                                [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
                                (mdl_Submit)="submitMap($event)">

                            </custom-map>

                        </div>

                        <!-- توضیحات -->

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">description</mat-icon>

                            </span>

                            <textarea style="height: 100px;" type="text" class="w-100 mb-3 form-control"
                                placeholder="مثلا: بهترین ساعت حضور کارشناس نصب و توضیحات تکمیلی..."
                                formControlName="strComment"></textarea>

                        </div>

                        <!-- قوانین ثبت‌ نام -->

                        <div class="d-flex">

                            <input type="checkbox" formControlName="rules" (change)="checkRules($event)" required>

                            <label class="px-1">

                                <a class="pointer" style="text-decoration: underline;" (click)="openAdd()">قوانین و مقررات</a> را مطالعه کردم و موافقم

                            </label>

                        </div>

                    </ng-container>

                    <!-- فرم OTP -->

                    <ng-container *ngIf="isOtpMode">

                        <div class="form-group has-icon">

                            <span class="form-control-icon">

                                <mat-icon class="mat-18">sms</mat-icon>

                            </span>

                            <input class="w-100 my-3 form-control" formControlName="strActivateCode" inputmode="numeric"
                                placeholder="کد تایید" oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                maxlength="4" type="text" />

                        </div>

                    </ng-container>

                </form>

                <div class="modal-footer d-flex flex-row-reverse justify-content-end">

                    <button type="button" class="btn btn-primary px-4" (click)="onSubmit()"
                        [disabled]="isSubmitDisabled">

                        {{ (!bSendOtp && !bLoginMode) ? 'ثبت نام' : 'تایید' }}

                    </button>

                    <button *ngIf="bSendOtp && !bLoginMode" type="button" class="btn btn-outline-dark px-4"
                        (click)="sendAgain_Otp()" [disabled]="otpTimer !== 0">

                        ارسال مجدد کد

                        <span *ngIf="otpTimer !== 0" class="me-1">

                            {{ otpTimer | faNum }}

                        </span>

                    </button>

                </div>

            </div>

            <ng-container *ngIf="isLoginMode">

                <div class="alert alert-secondary my-0 mt-2">
                    <p class="my-0 p-0">

                        <small class="fw-bold">
                            {{' در صورت بروز مشکل یا نیاز به راهنمایی، لطفاً با شماره‌های زیر تماس حاصل فرمایید:
                            09177563345 - 2-77273160-021' | faNum
                            }}
                        </small>
                    </p>
                </div>

            </ng-container>

        </div>

    </div>

</main>